<!--
 * @Author: wsx
 * @Date: 2022-01-11 09:54:13
 * @LastEditTime: 2022-01-19 09:38:52
 * @LastEditors: your name
 * @Description:自动单选穿梭框穿梭框
-->
<template>
  <el-dialog v-model="uniqueVisible" width="50%" @close="clsoe">
    <div id="uniqueTransfer" class="uniqueTransfer">
      <el-card class="h-transfer-panel">
        <template #header>
          <div class="card-header">
            <span class="title">待选</span>
          </div>
        </template>
        <div class="h-transfer-panel__body">
          <el-input
            v-model="filterText"
            placeholder="请输入关键词"
            class="h-transfer-panel__filter"
          >
            <template #prefix>
              <i class="iconfont icon-31sousuo"></i>
            </template>
          </el-input>
          <div class="h-transfer-panel__list">
            <el-tree
              class="h-transfer-panel__tree"
              ref="treeRef"
              :data="treeData"
              node-key="id"
              show-checkbox
              :props="{ label: labelText, children: chilText }"
              :default-expanded-keys="defaultExpandedKeys"
              :expand-on-click-node="true"
              :filter-node-method="filterNode"
              @check-change="handleCheckChange"
            >
            </el-tree>
          </div>
        </div>
      </el-card>
      <div class="h-transfer__buttons"></div>
      <el-card class="h-transfer-panel">
        <template #header>
          <div class="card-header">
            <span class="title">已选</span>
          </div>
        </template>
        <div class="h-transfer-panel__body">
          <el-input
            v-model="filterCheck"
            placeholder="请输入关键词"
            class="h-transfer-panel__filter"
          >
            <template #prefix>
              <i class="iconfont icon-31sousuo"></i>
            </template>
          </el-input>
          <div class="h-transfer-panel__list">
            <el-checkbox-group
              class="h-transfer-panel__group"
              v-model="checkList"
            >
              <template v-for="item in selectedList" :key="item[nodeKey]">
                <div class="selectedList">
                  <el-checkbox :label="item.id" @change="deleteCheck">
                    {{ item.name }}
                  </el-checkbox>
                </div>
              </template>
            </el-checkbox-group>
          </div>
        </div>
      </el-card>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <h-button type="primary" @click="getTaskSource">确定</h-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  ref,
  nextTick,
  computed,
  watchEffect,
} from "vue";
import _ from "lodash";
import {
  tasksFilesList,
  clueTasks,
} from "@/api/smartApplication/smartApplicationApi.js";
export default defineComponent({
  name: "",
  components: {},
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    nodeKey: {
      type: String,
      default: "id",
    },
    checkedKey: {
      type: String,
      default: "id",
    },
    dataType: {
      type: String,
      default: "",
    },

    areaCameraArry: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    // modelValue: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const state = reactive({
      uniqueVisible: false,
      treeData: [],
      labelText: "name",
      chilText: "children",
      filterText: "",
      filterCheck: "",
      selectedList: [],
      sourceList: [],
      checkList: [],
      selectTypeList: [],
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    // 使用wache监听不报红
    watchEffect(() => {
      state.uniqueVisible = props.visible;
    });
    watchEffect(() => {
      if (props.dataType) {
        nextTick(() => {
          state.treeData = [];
          state.selectedList = [];
          queryDataAsync();
        });
      }
    });
    watch(
      () => state.filterText,
      (v) => {
        treeRef.value && treeRef.value.filter(v);
      }
    );
    watch(
      () => state.filterCheck,
      (v) => {
        const list = state.sourceList.filter((item) => {
          return item[state.labelText].includes(v);
        });
        _.cloneDeep(list);
      }
    );
    // watch(
    //   () => state.selectedList,
    //   (v) => {
    //     context.emit("update:modelValue", v);
    //   }
    // );
    const queryDataAsync = async () => {
      let result;
      if (props.dataType === "任务") {
        result = await tasksFilesList({});
        changeListName(result.list, "taskName");
        state.treeData = result.list;
      } else if (props.dataType === "线索") {
        result = await clueTasks({});
        changeListName(result.list, "clueTaskName");
        state.treeData = result.list;
      }
    };

    // 对树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data[state.labelText].indexOf(value) !== -1;
    };
    // 选中框点击
    const handleCheckChange = (value) => {
      if (treeRef.value) {
        let currentNode = treeRef.value.getCheckedNodes().length;
        if (currentNode >= 1) {
          treeRef.value.setCheckedNodes([]);
          treeRef.value.setChecked(value, true);
          state.selectedList = treeRef.value.getCheckedNodes();
          state.checkList = [treeRef.value.getCheckedNodes()[0].id];
        } else {
          state.selectedList = [];
          state.checkList = [];
        }
      }
    };
    // 已添加的数据列表选中状态变化时触发
    const handleCheckedCitiesChange = (value) => {
      const checkedCount = value.length;
      state.checked2 = checkedCount === state.sourceList.length;
      isIndeterminate.value =
        checkedCount > 0 && checkedCount < state.sourceList.length;
    };

    //删除选择数据
    const deleteCheck = (list, str) => {
      state.selectedList = [];
      console.log("treeRef.value");
      console.log(treeRef.value.getCheckedNodes(), 99999999);
      treeRef.value.setChecked(treeRef.value.getCheckedNodes()[0], false);
    };
    //添加穿梭框需要渲染的属性名
    const changeListName = (list, str) => {
      list.forEach((item) => {
        item.name = item[str];
      });
    };
    //获取穿梭框摄像头数据
    const getTaskSource = () => {
      context.emit("videoSource", state.selectedList);
      clsoe();
    };
    //关闭
    const clsoe = () => {
      context.emit("update:visible", false);
    };
    return {
      ...refData,
      treeRef,
      filterNode,
      handleCheckedCitiesChange,
      handleCheckChange,
      getTaskSource,
      clsoe,
      deleteCheck,
    };
  },
});
</script>
<style lang="scss" scoped>
.uniqueTransfer {
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: row;
  .h-transfer-panel {
    flex: 1;
    .card-header {
      text-align: end;
      height: 40px;
      .title {
        font-size: 18px;
        font-weight: 600;
        line-height: 40px;
      }
    }
    :deep(.el-card__header) {
      padding: 0 10px;
    }
    .h-transfer-panel__body {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .h-transfer-panel__list {
        flex: 1;
        overflow: auto;
        margin-top: 5px;
        .h-transfer-panel__group {
          display: flex;
          flex-direction: column;
          .selectedList {
            @include flex-row-sb-c;
            padding: 0 8px 0 0;
          }
          // :deep(.el-checkbox__label) {
          //   width: 100%;
          //   @include flex-row-sb-c;
          // }
          // :deep(.el-checkbox:last-of-type) {
          //   margin-right: 30px;
          // }
        }
      }
    }
  }
  .h-transfer__buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    :deep(.el-button) {
      margin: 10px 0;
    }
  }
}
</style>
